export default "__VITE_ASSET__BIuqmGg___"